export const DoormanArt = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 130 130">
    <g clipPath="url(#a)">
      <circle cx="65.14" cy="65.14" r="65.14" fill="#99BFBC" />
      <path fill="#D09C8C" d="M81.77 55.85v15.2H97.5v-15.2H81.77Z" />
      <path
        fill="#12284D"
        d="M57.88 76.52c-3.03 3.04-4.52 20.8-4.88 29.3h37.45V69.47c-8.68-.54-2.17-.54-7.6-1.08-5.43-.55-21.17 4.34-24.97 8.14Z"
      />
      <circle cx="77.97" cy="79.19" r="2.17" fill="#fff" />
      <circle cx="79.05" cy="90.05" r="2.17" fill="#fff" />
      <circle cx="80.14" cy="100.9" r="2.17" fill="#fff" />
      <path
        fill="#12284D"
        fillRule="evenodd"
        d="M116.03 105.83H89.9V69.46c4.87-.3 4.96-.44 5.06-.6.07-.11.16-.25 2.54-.48 5.42-.55 21.16 4.34 24.96 8.14 1.5 1.49 2.6 6.51 3.4 12.25a65.07 65.07 0 0 1-9.84 17.06Z"
        clipRule="evenodd"
      />
      <circle cx="2.17" cy="2.17" r="2.17" fill="#fff" transform="matrix(-1 0 0 1 104.56 77.02)" />
      <circle cx="2.17" cy="2.17" r="2.17" fill="#fff" transform="matrix(-1 0 0 1 103.48 87.87)" />
      <circle cx="2.17" cy="2.17" r="2.17" fill="#fff" transform="matrix(-1 0 0 1 102.4 98.73)" />
      <path
        fill="#fff"
        d="m102.93 68.88-3.8-3.8-5.97 3.25v6.52l9.77-5.97ZM76.88 68.88l3.8-3.8 5.97 3.25v6.52l-9.77-5.97Z"
      />
      <path
        fill="#E0AB9A"
        fillRule="evenodd"
        d="M73.5 47.68c-.53-.97-1.02-1.88-1.5-2.68v-.63c-2.25-.74-2.72-6.04-2.72-8.06 0-2.17.55-4.88 1.63-4.88.87 0 1.09 2.17 1.09 3.25v-4.34h17.37l.27.81.27-.8h17.37v4.33c0-1.08.21-3.25 1.08-3.25 1.09 0 1.63 2.71 1.63 4.88 0 2.02-.47 7.32-2.71 8.06V45c-.49.8-.98 1.71-1.5 2.68-3.03 5.57-7.09 13.06-15.87 13.06l-.27-.01h-.27c-8.79 0-12.85-7.48-15.87-13.05Z"
        clipRule="evenodd"
      />
      <ellipse cx="89.75" cy="17.29" fill="#EF4931" rx="23.75" ry="13" />
      <path
        fill="#12284D"
        fillRule="evenodd"
        d="M107.3 23.58v6.36c-2.57 3.7-9.5 6.35-17.65 6.35-8.14 0-15.07-2.65-17.65-6.34v-6.38c2.58-3.7 9.5-6.34 17.65-6.34 8.15 0 15.08 2.65 17.65 6.35Z"
        clipRule="evenodd"
      />
      <ellipse cx="89.65" cy="29.79" fill="#0F3C6C" rx="17.65" ry="6.5" />
      <path
        fill="#D9D9D9"
        fillRule="evenodd"
        d="M116.45 105.29a65.03 65.03 0 0 1-51.3 25 65.03 65.03 0 0 1-51.32-25h102.62Z"
        clipRule="evenodd"
      />
      <path fill="#DBCABC" d="M15.27 72.55 14 116.45l27.8-.05-1.92-43.89-24.6.04Z" />
      <path fill="#836D5E" d="m39.88 72.51 4.07 37.82-1.24.62-.92 5.45" />
      <path
        fill="#74A6A2"
        d="m31.88 81.71-8.72.02c-1.1 0-2.01-.9-2.02-2.01v-.32c0-1.11.9-2.02 2.01-2.03l8.72-.01c1.1 0 2.02.9 2.02 2v.33c0 1.11-.9 2.02-2 2.02Z"
      />
      <path fill="#FFD300" d="M19.65 110.7h-1.43a.55.55 0 0 0 0 1.1h1.43v-1.1Z" />
      <path fill="#99BFBC" d="M21.67 111.24c0-.3-.25-.54-.55-.54h-1.47v1.1h1.47c.3 0 .55-.25.55-.56Z" />
      <path fill="#0F3C6C" d="M19.67 113.25c.3 0 .55-.25.55-.55v-2l-1.1 1.1v.9c0 .3.25.55.55.55Z" />
      <path fill="#EF4931" d="M19.67 109.24c-.3 0-.55.25-.55.55v2l1.1-1.1v-.9c0-.3-.25-.55-.55-.55Z" />
      <path fill="#fff" d="m34.4 91.4-13.66.05.01 9.83 13.66-.04-.01-9.84Z" />
      <path
        fill="#0F3C6C"
        d="m31.3 94.3-7.35.02v.46l7.34-.02v-.47ZM31.3 97.9l-5.27.02v.47l5.26-.02v-.46ZM24.87 97.93h-.92v.46h.92v-.46ZM31.3 96.06l-5.27.02v.46l5.27-.01v-.47ZM24.89 96.08h-.93v.47h.93v-.47Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h130v130H0z" />
      </clipPath>
    </defs>
  </svg>
);
